<template>
  <section class="group flex items-center justify-between p-2 rounded-8 hover:bg-primary-tints-150">
    <div class="flex gap-x-4 items-center">
      <contact-avatar
        :name="callback.src"
      />
      <div>
        <p class="mb-2 gap-1 items-center grid grid-cols-[1fr_auto_1fr]">
          <span
            class="text-1416 truncate"
            :title="callback.src"
            data-test="callback-src"
          >
            {{ callback.src }}
          </span>

          <wui-icon
            name="forwardRight"
            small
            class="text-primary-tints-800"
          />
          <span
            v-if="callback.dst?.length"
            class="text-1416 truncate grow"
            :title="callback.dst"
            data-test="callback-dst"
          >
            {{ callback.dst }}
          </span>
          <span
            v-else
            class="text-1416 truncate"
            data-test="callback-dst-empty"
          >
            {{ $t('mainAside.emptyDstNumber') }}
          </span>
        </p>

        <p
          class="text-1316 text-primary-tints-800 font-light"
          data-test="callback-label"
        >
          {{ $t('mainAside.webCallBackorder') }}
        </p>
      </div>
    </div>
    <div>
      <p
        class="text-primary group-hover:hidden"
        data-test="callback-time"
      >
        {{ dayjs(callback.datetime).tz().format(TIME_FORMAT) }}
      </p>
      <wui-btn
        class="hidden! group-hover:inline-block!"
        icon
        :size="32"
        variant="negative"
        state="tonal"
        prepend-icon="trashM"
        auto-loading
        @click="deleteCallBack(callback.guid)"
      >
        <span
          class="sr-only select-none"
          data-test="callback-sr-only"
        >Remove callback</span>
      </wui-btn>
    </div>
  </section>
</template>
<script setup lang="ts">
import { WuiBtn, WuiIcon } from '@wui/common-library'
import dayjs from 'dayjs'

import { ContactAvatar } from '@/entities/contact-avatar'
import { useCallBack } from '@/entities/webCallBackOrder'

import { CallBack } from '@/shared/types/api'
import { TIME_FORMAT } from '@/shared/utils/constants'

defineProps<{
  callback: CallBack
}>()

const storeCallBack = useCallBack()
const { deleteCallBack } = storeCallBack

</script>
